import { render, staticRenderFns } from "./Prix.vue?vue&type=template&id=81d03d8e&scoped=true"
import script from "./Prix.vue?vue&type=script&lang=js"
export * from "./Prix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d03d8e",
  null
  
)

export default component.exports